export default __webpack_public_path__ + "static/media/home-bg2.aaa89c7a.svg";